import React, { useState } from 'react'
import { StyleSheet, css } from 'aphrodite'
import { PropTypes } from 'prop-types'
import {
  COLOR_BLACK,
  COLOR_ERROR,
  COLOR_WHITE,
  COLOR_GRAY__300,
} from '../../lib/colors'
import { IconMic, IconMicOff, IconMute, IconMore, IconVolume } from '../Icon'
import UIButtonIcon from '../UI/UIButtonIcon'
import phone from '../../assets/icon-phone.svg'
import { useTranslation } from 'react-i18next'
import UIButton from '../UI/UIButton'
import { toast } from 'react-toastify'
import ReportMakerPopup from '../../modal/ReportMakerPopup'
import Popover from 'react-awesome-popover'

const WidgetLiveControl = ({
  onMicClicked,
  onVolumeCliked,
  onEndLive,
  dynamicStyle,
}) => {
  const [isMicOff, setMicOff] = useState(false)
  const [isVolumeOff, setVolumeOff] = useState(false)

  const { t } = useTranslation('translation')

  const handleMic = () => {
    setMicOff((prev) => !prev)
    onMicClicked()
  }

  const handleVolume = () => {
    setVolumeOff((prev) => !prev)
    onVolumeCliked()
  }

  const handleReportMaker = () => {
    toast(<ReportMakerPopup onEndLive={onEndLive} />, {
      autoClose: false,
      closeOnClick: false,
      draggable: true,
      closeButton: false,
    })
  }

  const handleEndLive = () => {
    toast(<EndLivePopup onContinue={onEndLive} />, {
      autoClose: false,
      closeOnClick: false,
      draggable: true,
      closeButton: false,
    })
  }

  return (
    <div className={css(styles.container, dynamicStyle && dynamicStyle)}>
      <div className={css(styles.containerControls)}>
        <UIButtonIcon onClick={handleMic}>
          {isMicOff ? (
            <IconMicOff color={COLOR_BLACK} />
          ) : (
            <IconMic color={COLOR_BLACK} />
          )}
        </UIButtonIcon>
        <UIButtonIcon onClick={handleVolume}>
          {isVolumeOff ? (
            <IconMute color={COLOR_BLACK} />
          ) : (
            <IconVolume color={COLOR_BLACK} />
          )}
        </UIButtonIcon>
        <Popover arrow={false}>
          <UIButtonIcon>
            <IconMore color={COLOR_BLACK} />
          </UIButtonIcon>
          <div className={css(styles.popover)} onClick={handleReportMaker}>
            {t('pages.live.reportMaker')}
          </div>
        </Popover>
      </div>
      <div className={css(styles.containerEnd)} onClick={handleEndLive}>
        <UIButtonIcon dynamicStyle={styles.phoneIconButton}>
          <img src={phone} className={css(styles.phoneIcon)} />
        </UIButtonIcon>
      </div>
    </div>
  )
}

const EndLivePopup = ({ closeToast, onContinue }) => {
  const { t } = useTranslation('translation')
  return (
    <div className={css(styles.containerPopup)}>
      <p>{t('pages.live.endLiveMessage')}</p>
      <div className={css(styles.containerButtonPopup)}>
        <UIButton
          design="invertedPrimary"
          label={t('common.button.no')}
          onClick={closeToast}
        />
        <UIButton
          design="primary"
          label={t('common.button.yes')}
          onClick={() => {
            onContinue()
            closeToast()
          }}
        />
      </div>
    </div>
  )
}

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: '1.2em',
  },
  containerControls: {
    display: 'flex',
    alignItems: 'center',
    borderRadius: '20px',
    padding: '0em 1.2em',
    background: COLOR_WHITE,
  },
  containerEnd: {
    padding: '0em 1em',
    borderRadius: '30px',
    backgroundColor: COLOR_ERROR,
  },
  phoneIconButton: {
    padding: 10,
  },
  phoneIcon: {
    width: '2em',
  },
  containerPopup: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    fontWeight: 700,
    color: COLOR_BLACK,
    backgroundColor: COLOR_WHITE,
    padding: '3em',
  },
  containerButtonPopup: {
    display: 'flex',
    alignItems: 'center',
    gap: '2em',
    fontWeight: 700,
    color: COLOR_WHITE,
  },
  popover: {
    backgroundColor: COLOR_WHITE,
    padding: '1em',
    borderRadius: '15px',
    minWidth: '200px',
    cursor: 'pointer',
    ':hover': {
      backgroundColor: COLOR_GRAY__300,
    },
  },
})

EndLivePopup.propTypes = {
  onContinue: PropTypes.func,
  closeToast: PropTypes.func,
}

WidgetLiveControl.propTypes = {
  onMicClicked: PropTypes.func,
  onVolumeCliked: PropTypes.func,
  onEndLive: PropTypes.func,
  dynamicStyle: PropTypes.object,
}

export default WidgetLiveControl
